import { compileProducts } from '@/js/analytics/utils'
import { PURCHASED_ITEMS, SEND_EVENT } from '@/js/analytics/const'

export default function sendPurchasedItems(order, cart, GUID) {
  console.log('sendPurchasedItems', cart);
  if ('undefined' === typeof window.eS) return false
  const products = compileProducts(cart.groups)
  // eslint-disable-next-line no-undef
  eS(SEND_EVENT, PURCHASED_ITEMS, {
    [PURCHASED_ITEMS]: products,
    OrderNumber: order,
    GUID,
  })
  return false
}
